import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { TranslocoService } from '@jsverse/transloco';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { map, startWith, takeUntil, catchError, timeout } from 'rxjs/operators';
import { Flightinfo } from '../../../../../../../../../app/models/flightModel';
import { OrderBundleType } from '../../../../../../../../../app/models/orderBundle.models';
import { Person, PERSONS } from '../../../../../../../../../app/models/persons';
import { ProductOption, PRODUCT_OPTIONS } from '../../../../../../../../../app/models/productOption';
import { ShuttelbussService } from '../../../../../../../../../app/services/shuttlebuss.service';
import { SnackbarService } from '../../../../../../../../../app/services/snackbar.service';
import { ParkingService } from '../../../../../../../../../app/services/parking.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BackOffice24StatesService } from '../../../../../../../../../app/home/admin/back-office24/state/back-office24-states.service';
import { MyConfigService } from '../../../../../../../../../app/services/my-config.service';
import { CartService } from '../../../../../../../../../app/services/cart.service';
import { BookingConfigService } from '../../../../../../../../../app/parkifly-bookings/services/booking-config.service';
import { InternalBookingSummaryComponent } from '../internal-booking-summary/internal-booking-summary.component';
import { BackOfficeService } from '../../../../../../../../../app/services/backoffice.service';
import { SelfServiceService } from '../../../../../../../../../app/services/self-service.service';
import { AuthService } from '../../../../../../../../../app/services/auth.service';

@Component({
  selector: 'app-internal-booking-form',
  templateUrl: './internal-booking-form.component.html',
  styleUrl: './internal-booking-form.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class InternalBookingFormComponent implements OnInit, OnDestroy {
  public datepipe: DatePipe;
  persons: Person[] = PERSONS;
  productOption: ProductOption[] = [
    { value: 'PSVING', viewValue: 'Charter Ving parkering med transfer', price: 0 },
    { value: 'PSVING1VECKA', viewValue: 'Charter Ving parkering 1 vecka med transfer', price: 522 },
    { value: 'PSVING2VECKA', viewValue: 'Charter Ving parkering 2 veckor med transfer', price: 747 },
    { value: 'PSVING3VECKA', viewValue: 'Charter Ving parkering 3 veckor med transfer', price: 1070 },
    { value: 'PSVING4VECKA', viewValue: 'Charter Ving parkering 4 veckor med transfer', price: 1390 }];
  bookingForm: UntypedFormGroup;
  isLoading = false;
  isLoadingArrival = false;
  isLoadingDeparture = false;
  minDepartureDate: Date = new Date();
  minArrivalDate: Date = new Date();
  minHotelArrivalDate: Date = new Date();
  minSimpleArrivalDate: Date = new Date();
  arrivalFlights: Flightinfo[] = [];
  departureFlights: Flightinfo[] = [];
  currentUtcTime: string = moment.utc().format();
  selectedArrivalTime: Moment;
  arrivalTerminal: string;
  departureTerminal: string;
  bundle: OrderBundleType;
  travelAgencyBundle: string;
  productCode: string;
  arriveAtParking60Min: string;
  arriveAtParking75Min: string;
  arriveAtParking90Min: string;
  arriveAtParking105Min: string;
  arriveAtParking120Min: string;
  arriveAtParking135Min: string;
  arriveAtParking150Min: string;
  arriveAtParking165Min: string;
  arriveAtParking180Min: string;
  arriveAtParking195Min: string;
  arriveAtParking210Min: string;
  arriveAtParking225Min: string;
  arriveAtParking240Min: string;
  arriveAtParking255Min: string;
  arriveAtParking270Min: string;
  componentDestroyed$: Subject<boolean> = new Subject();
  filteredOptionsFlightsDepartures: Observable<Flightinfo[]>;
  filteredOptionsFlightsArrivals: Observable<Flightinfo[]>;
  filteredDepartureTimeOptions: Observable<string[]>;
  filteredArrivalTimeOptions: Observable<string[]>;
  filteredHotelDepartureTimeOptions: Observable<string[]>;
  filteredHotelArrivalTimeOptions: Observable<string[]>;
  hasAvailableParking = true;
  selectedFlight: Flightinfo = null;
  departHour: number;
  departMinute: number;
  arriveHour: number;
  arriveMinute: number;
  selectedArrival: Flightinfo;
  selectedDeparture: Flightinfo;
  organization: any = null;
  private orgSubscription: Subscription = new Subscription();
  allOrgs: any[] = [];
  tentantConfigSortingParking: any = {
    'skavsta': (parkings: any[]) => {
      []
      if (parkings.length > 1) {
        const firstItem = parkings.shift();
        parkings.push(firstItem);
      }
      return parkings;
    }
  };
  parkings: any[] = [];
  isDiscountCodeWrong: boolean = false;
  selectedParking: any;
  additionalServices: any = [];
  departSecond: number;
  arriveSecond: number;
  locale: string = "sv";
  hotelOptions: any = [];
  isLoadingParkings: boolean = false;
  timeoutError: boolean = false;
  showSimpleBooking: boolean = false;
  timeOptions: string[] = [];
  hotelArrivalTimeOptions: string[] = [];
  showQualityLongTermForm: boolean = true;
  selectedOrg: any;
  orgName: any;
  isLoadingOrganization: boolean = false;
  isLoggedIn: boolean = false;
  parkingOperators: any[] = [];
  orgId: any;
  showSubscription: boolean = false;
  isResetting: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private shuttleBussService: ShuttelbussService,
    public snackbar: SnackbarService,
    public translate: TranslocoService,
    private bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    private parkingService: ParkingService,
    public backOffice24StatesService: BackOffice24StatesService,
    private myConfigService: MyConfigService,
    private cartService: CartService,
    private http: HttpClient,
    private bookingConfigService: BookingConfigService,
    private backOfficeService: BackOfficeService,
    private selfServiceService: SelfServiceService,
    public authService: AuthService
  ) {
    this.translate.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });
  }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.pipe(
      takeUntil(this.componentDestroyed$)
    ).subscribe(org => {
      this.orgName = org;
      this.organization = org;
      if (this.organization?.organizationId?.toLowerCase() === '942ce067-7848-4441-b746-8f6eed7395bb') {
        this.showQualityLongTermForm = true;
      } else {
        this.showQualityLongTermForm = false;
      }
    });

    this.isLoadingOrganization = true;

    this.backOfficeService.getOrganizations(this.organization.organizationId || 'a848ccd3-fd8d-4035-925e-571ebb4e93e8').pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (data) => {
          this.selectedOrg = data;
          if (this.selectedOrg?.type == "ParkingOperator" || this.selectedOrg?.type == "TravelAgency" || this.selectedOrg?.type == "ParkingCompany") {
            this.allOrgs.push({
              name: this.selectedOrg?.name,
              organizationId: this.selectedOrg?.id,
            });

            if (this.selectedOrg.organizations && Array.isArray(this.selectedOrg.organizations)) {
              this.selectedOrg.organizations.forEach((subOrg: any) => {
                if (subOrg?.type == "ParkingOperator" || subOrg?.type == "TravelAgency" || subOrg?.type == "ParkingCompany") {
                  this.allOrgs.push({
                    name: subOrg.name,
                    organizationId: subOrg.id,
                  });
                }
              });
            }
          }

          if (this.allOrgs.length > 0) {
            this.bookingForm.patchValue({ organization: this.allOrgs[0] });
            this.selectOrganization({ value: this.allOrgs[0] } as MatSelectChange);
          }

          this.isLoadingOrganization = false;
        },
        error: (error) => {
          this.isLoadingOrganization = false;
        }
      });

    this._initForm();
    this.formReset();
    this.generateTimeOptions();

    if (this.authService.loggedIn()) {
      this.isLoggedIn = true;
    }

    this.selfServiceService.getParkingOperators('SWE').then((result) => {
      this.parkingOperators = result?.stations || [];
    });

  }

  getTravelAgencyBundle(event: MatSelectChange) {
    if (event.value === 'PSVING') {
      this.productCode = 'PARKCHARTER';
    }
    if (event.value === 'PSTUI1VECKA') {
      this.productCode = 'PARKCHARTER1VECKA';
    }
    if (event.value === 'PSVING1VECKA') {
      this.productCode = 'PARKCHARTER1VECKA';
    }
    if (event.value === 'PSVING2VECKA') {
      this.productCode = 'PARKCHARTER2VECKA';
    }
    if (event.value === 'PSVING3VECKA') {
      this.productCode = 'PARKCHARTER3VECKA';
    }
    if (event.value === 'PSVING4VECKA') {
      this.productCode = 'PARKCHARTER4VECKA';
    }
    this.travelAgencyBundle = event.value;
    this.selectedParking = { id: '8C98315A-B2AD-4E70-86F9-5D54992FED26', name: "Flygets P1", bundleCode: event.value, productCode: this.productCode, availableParkingSpots: 0, overbooking: true };
    this.updateContinueBookingWithPriceState();
  }

  onDepartureNumberChange(searchValue: string): void {
    this.selectedFlight = null;
  }

  getParkingTime(event: MatSelectChange) {
    this.departHour = moment(event.value).get('hour');
    this.departMinute = moment(event.value).get('minute');
    this.departSecond = moment(event.value).get('second');
  }

  onArrivalNumberChange(searchValue: string): void {
    this.bookingForm.controls['flightArrivalId'].patchValue('');
  }

  displayArrivalFlightWrapper() {
    return (offer) => this.displayArrivalFlight(offer);
  }

  displayArrivalFlight(option?: any): string | undefined {
    if (option == '') {
      return '';
    }
    let formattedDate = (moment(option.arrivalTime.scheduled)).format('HH:mm')
    let departureAirport = '';
    if (this.translate.getActiveLang() == 'sv') {
      departureAirport = option.departureAirportSwedish;
    }
    else if (this.translate.getActiveLang() == 'en') {
      departureAirport = option.departureAirportEnglish;
    }
    this.selectedArrivalTime = moment(option.arrivalTime.scheduled);
    this.arrivalTerminal = option.locationAndStatus.terminal;
    this.arriveHour = moment(this.selectedArrivalTime).get('hour');
    this.arriveMinute = moment(this.selectedArrivalTime).get('minute');
    this.arriveSecond = moment(this.selectedArrivalTime).get('second');
    this.bookingForm.controls['flightArrivalId'].patchValue(option.flightId);

    return option ? option.flightId + ' ' + departureAirport + ' ' + formattedDate : null;
  }

  checkIfFlightExists() {
    this.bookingForm.controls['flightDepartureNumber'].valueChanges
      .pipe()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((result: string) => {
        this.departureFlights.forEach(flight => {
          if (flight.flightId !== result) {
            this.bookingForm.controls['parkingfrom'].disable();
            this.bookingForm.controls['parkingfrom'].updateValueAndValidity();
          }
        });
      });
  }

  isSelected(item: any): boolean {
    const selected = this.bookingForm.get('additionalServices')?.value || [];
    return selected.some((s: any) => s.id === item.id);
  }

  compareServices = (a: any, b: any) => a?.id === b?.id;

  private _initForm() {
    this.bookingForm = this.fb.group({
      flightDepartureDate: ['', Validators.required],
      flightDepartureNumber: ['', [Validators.pattern(/^\S*$/), Validators.required]],
      parkingfrom: ['', Validators.required],
      flightArrivalDate: ['', Validators.required],
      flightArrivalNumber: ['', [Validators.required]],
      flightArrivalId: ['', [Validators.pattern(/^\S*$/), Validators.required]],
      carid: ['XXX123', [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern(/^[A-Z0-9]{4,9}$/)]],
      bookingNumber: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', Validators.required],
      cellular: ['', Validators.required],
      persons: ['', Validators.required],
      onlyHandBaggage: [false],
      overrideParking: [false],
      continueBookingWithPrice: [{ value: false, disabled: true }],
      customPrice: [null],
      comment: [''],
      organization: ['', Validators.required],
      parking: [''],
      parkingto: [''],
      additionalServices: [[]],
      departureType: ['flight'],
      arrivalType: ['flight'],
      hotelArrivalDate: [''],
      hotelDepartureDate: [''],
      hotelArrivalTime: [''],
      hotelDepartureTime: [''],
      arrivalHotel: [''],
      departureHotel: [''],
      simpleDepartureDate: [''],
      simpleDepartureTime: [''],
      simpleArrivalDate: [''],
      simpleArrivalTime: [''],
      travelAgency: ['', Validators.required],
      subscription: [false]
    });

    // Watch form changes to update charge customer with price checkbox state
    this.bookingForm.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.updateContinueBookingWithPriceState();
    });

    // Watch for changes in additional services
    this.bookingForm.get('additionalServices')?.valueChanges.subscribe(services => {
      this.handleAdditionalServicesChange(services);
    });

    // Setup time autocomplete filters
    this.filteredDepartureTimeOptions = this.bookingForm.get('simpleDepartureTime')!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterTimeOptions(value))
    );
    this.filteredArrivalTimeOptions = this.bookingForm.get('simpleArrivalTime')!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterTimeOptions(value))
    );
    this.filteredHotelDepartureTimeOptions = this.bookingForm.get('hotelDepartureTime')!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterTimeOptions(value))
    );
    this.filteredHotelArrivalTimeOptions = this.bookingForm.get('hotelArrivalTime')!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterHotelArrivalTimeOptions(value))
    );

    // Watch for date changes to clear corresponding time fields only
    this.bookingForm.get('simpleDepartureDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('simpleDepartureTime')?.setValue('');
        this.bookingForm.get('simpleArrivalDate')?.setValue('');
        this.bookingForm.get('simpleArrivalTime')?.setValue('');
      }
    });
    this.bookingForm.get('simpleArrivalDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('simpleArrivalTime')?.setValue('');
      }
    });
    this.bookingForm.get('flightDepartureDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('flightDepartureNumber')?.setValue('');
        this.bookingForm.get('flightArrivalDate')?.setValue('');
        this.bookingForm.get('flightArrivalNumber')?.setValue('');

        this.bookingForm.get('hotelArrivalDate')?.setValue('');
        this.bookingForm.get('hotelArrivalTime')?.setValue('');
      }
    })
    this.bookingForm.get('flightArrivalDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('flightArrivalNumber')?.setValue('');
      }
    })
    this.bookingForm.get('hotelDepartureDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('hotelDepartureTime')?.setValue('');
        this.bookingForm.get('hotelArrivalDate')?.setValue('');
        this.bookingForm.get('hotelArrivalTime')?.setValue('');

        this.bookingForm.get('flightArrivalDate')?.setValue('');
        this.bookingForm.get('flightArrivalNumber')?.setValue('');
      }
    });
    this.bookingForm.get('hotelArrivalDate')?.valueChanges.subscribe((value) => {
      if (value) {
        this.bookingForm.get('hotelArrivalTime')?.setValue('');
      }
    });

    // Watch for time changes to trigger parking options fetch
    this.bookingForm.get('simpleDepartureTime')?.valueChanges.subscribe((value) => {
      if (value && value.length === 5 && value.includes(':')) this.showParkingOptions();
    });
    this.bookingForm.get('simpleArrivalTime')?.valueChanges.subscribe((value) => {
      if (value && value.length === 5 && value.includes(':') && !this.bookingForm.get('subscription')?.value) this.showParkingOptions();
    });
    this.bookingForm.get('hotelDepartureTime')?.valueChanges.subscribe((value) => {
      if (value && value.length === 5 && value.includes(':')) this.showParkingOptions();
    });
    this.bookingForm.get('hotelArrivalTime')?.valueChanges.subscribe((value) => {
      if (value && value.length === 5 && value.includes(':') && !this.bookingForm.get('subscription')?.value) this.showParkingOptions();
    });
    this.bookingForm.get('parkingfrom')?.valueChanges.subscribe((value) => {
      if (value) this.showParkingOptions();
    });
  }

  formReset() {
    this.shuttleBussService.onFormReset.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.resetForm();
    });
  }

  private _filterAutocompleteDepartures(value: string): Flightinfo[] {
    const filterValue = value.toLowerCase();
    return this.departureFlights.filter(
      option =>
        option.flightId.toLowerCase().includes(filterValue) ||
        option.arrivalAirportSwedish.toLowerCase().includes(filterValue) ||
        option.arrivalAirportEnglish.toLowerCase().includes(filterValue) ||
        option.codeShareData
          .toString()
          .toLowerCase()
          .includes(filterValue)
    );
  }

  private _filterAutocompleteArrivals(value: string): Flightinfo[] {
    const filterValue = (value as any)?.toLowerCase();
    return this.arrivalFlights?.filter(
      option =>
        option.flightId.toLowerCase().includes(filterValue) ||
        option.departureAirportSwedish.toLowerCase().includes(filterValue) ||
        option.departureAirportEnglish.toLowerCase().includes(filterValue) ||
        option.codeShareData
          .toString()
          .toLowerCase()
          .includes(filterValue)
    );
  }

  fetchParkings() {
    if (!this.organization) {
      this.snackbar.openSnackBar('Please select an organization first', '');
      return;
    }
    if (this.bookingForm.controls.parking.hasError('timeout')) {
      this.showParkingOptions();
    }
  }

  showParkingOptions() {

    if (this.isResetting) {
      return;
    }

    if (!this.canFetchParkingOptions()) {
      return;
    }

    const departureDateTime = this.getParkingDateTime('departure');
    let arrivalDateTime = this.getParkingDateTime('arrival');

    // If subscription is selected, set arrival date to 30 days after departure
    if (this.bookingForm.get('subscription')?.value && departureDateTime) {
      arrivalDateTime = moment(departureDateTime).add(30, 'days').format('YYYY-MM-DDTHH:mm:ss');
    }

    if (departureDateTime && arrivalDateTime) {
      // if (this.bookingForm.get('organization')?.value?.name?.toLowerCase() == 'ving') {
      //   this.getAvailableParkingsForOrganization(departureDateTime, arrivalDateTime, 'NONE');
      // } else {
      this.getAvailableParkingsForOrganization(departureDateTime, arrivalDateTime, 'NONE');
      // }
    }
  }

  canFetchParkingOptions(): boolean {
    // Check if organization is selected
    if (!this.bookingForm.get('organization')?.value) {
      return false;
    }

    if (this.showSimpleBooking) {
      if (this.bookingForm.get('subscription')?.value) {
        return !!(this.bookingForm.get('simpleDepartureDate')?.value &&
          this.bookingForm.get('simpleDepartureTime')?.value);
      }
      return !!(this.bookingForm.get('simpleDepartureDate')?.value &&
        this.bookingForm.get('simpleDepartureTime')?.value &&
        this.bookingForm.get('simpleArrivalDate')?.value &&
        this.bookingForm.get('simpleArrivalTime')?.value);
    } else {
      const departureType = this.bookingForm.get('departureType')?.value;
      const arrivalType = this.bookingForm.get('arrivalType')?.value;

      let departureReady = false;
      let arrivalReady = false;

      if (departureType === 'flight') {
        departureReady = !!(this.bookingForm.get('flightDepartureDate')?.value &&
          this.bookingForm.get('parkingfrom')?.value);
      } else if (departureType === 'hotel') {
        departureReady = !!(this.bookingForm.get('hotelDepartureDate')?.value &&
          this.bookingForm.get('hotelDepartureTime')?.value);
      }

      // If subscription is selected, only departure is required
      if (this.bookingForm.get('subscription')?.value) {
        return departureReady;
      }

      if (arrivalType === 'flight') {
        arrivalReady = !!(this.bookingForm.get('flightArrivalDate')?.value &&
          this.selectedArrival);
      } else if (arrivalType === 'hotel') {
        arrivalReady = !!(this.bookingForm.get('hotelArrivalDate')?.value &&
          this.bookingForm.get('hotelArrivalTime')?.value);
      }

      return departureReady && arrivalReady;
    }
  }

  onArrivalSelect(event: MatOptionSelectionChange) {
    const arrivalFlight = this.arrivalFlights.filter(
      flight => flight.flightId === event.source.value.flightId
    )[0];
    this.selectedArrival = arrivalFlight;
    this.arrivalTerminal = arrivalFlight.locationAndStatus.terminal;
    this.selectedArrivalTime = moment(arrivalFlight.arrivalTime.scheduled);
    this.arriveHour = this.selectedArrivalTime.get('hour');
    this.arriveMinute = this.selectedArrivalTime.get('minute');
    this.arriveSecond = this.selectedArrivalTime.get('second');
    this.showParkingOptions();
  }

  onDepartureSelect(event: MatSelectChange) {
    this.bookingForm.controls['parkingfrom'].reset('');
    const departureFlight = this.departureFlights.filter(
      flight => flight.flightId === event.source.value
    );
    this.selectedDeparture = departureFlight[0];
    this.selectedFlight = { ...departureFlight[0] };
    this.selectedArrivalTime = moment(this.selectedFlight.departureTime.scheduled);
    this.departureTerminal = this.selectedFlight.locationAndStatus.terminal;
    this.arriveAtParking60Min = moment(this.selectedArrivalTime)
      .subtract(60, 'm')
      .format();
    this.arriveAtParking75Min = moment(this.selectedArrivalTime)
      .subtract(75, 'm')
      .format();
    this.arriveAtParking90Min = moment(this.selectedArrivalTime)
      .subtract(90, 'm')
      .format();
    this.arriveAtParking105Min = moment(this.selectedArrivalTime)
      .subtract(105, 'm')
      .format();
    this.arriveAtParking120Min = moment(this.selectedArrivalTime)
      .subtract(120, 'm')
      .format();
    this.arriveAtParking135Min = moment(this.selectedArrivalTime)
      .subtract(135, 'm')
      .format();
    this.arriveAtParking150Min = moment(this.selectedArrivalTime)
      .subtract(150, 'm')
      .format();
    this.arriveAtParking165Min = moment(this.selectedArrivalTime)
      .subtract(165, 'm')
      .format();
    this.arriveAtParking180Min = moment(this.selectedArrivalTime)
      .subtract(180, 'm')
      .format();
    this.arriveAtParking195Min = moment(this.selectedArrivalTime)
      .subtract(195, 'm')
      .format();
    this.arriveAtParking210Min = moment(this.selectedArrivalTime)
      .subtract(210, 'm')
      .format();
    this.arriveAtParking225Min = moment(this.selectedArrivalTime)
      .subtract(225, 'm')
      .format();
    this.arriveAtParking240Min = moment(this.selectedArrivalTime)
      .subtract(240, 'm')
      .format();
    this.arriveAtParking255Min = moment(this.selectedArrivalTime)
      .subtract(255, 'm')
      .format();
    this.arriveAtParking270Min = moment(this.selectedArrivalTime)
      .subtract(270, 'm')
      .format();

    // Set default value after calculating all options
    setTimeout(() => {
      this.bookingForm.controls['parkingfrom'].setValue(this.arriveAtParking180Min);
    }, 0);
  }

  selectOrganization(event: MatSelectChange) {
    this.showSimpleBooking = false;
    this.organization = event?.value;
    if (this.organization?.name?.toLowerCase() === 'flygets.se' || this.organization?.name?.toLowerCase() === 'nazar' || this.organization?.name?.toLowerCase() === 'tui' || this.organization?.name?.toLowerCase() === 'ving') {
      this.getHotelSelectOptions().subscribe({
        next: (hotelOptions: any) => {
          hotelOptions.map((option: any) => {
            this.hotelOptions.push({ value: option.terminalName, viewValue: option.terminalName })
          })
        }
      });
    } else if (this.organization?.name?.toLowerCase() === 'skavsta' || this.organization?.name?.toLowerCase() === 'quality hotel arlanda xpo parkering') {
      this.showSimpleBooking = true;
    }

    const subscriptionExists = this.parkingOperators.some(station =>
      station.parkingOperators?.some(op => {
        return (op.organizationId?.toLowerCase() == this.organization?.organizationId?.toLowerCase()) && (op.subscriptionParking == true)
      })
    );
    this.showSubscription = subscriptionExists && this.isLoggedIn;
  }

  checkHotelOptions() {
    if (this.organization?.name?.toLowerCase() === 'flygets.se' || this.organization?.name?.toLowerCase() === 'nazar' || this.organization?.name?.toLowerCase() === 'tui' || this.organization?.name?.toLowerCase() === 'ving') {
      return true;
    } else {
      return false;
    }
  }

  isBookingNumberRequired() {
    return this.organization?.name?.toLowerCase() === 'tui' || this.organization?.name?.toLowerCase() === 'nazar' || this.organization?.name?.toLowerCase() === 'ving';
  }

  getHotelSelectOptions() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    const URL = `${hostPath}Shuttlebuss/Shuttlebuss.Service/ArrivalDeparture/terminals/59D90114-9889-474E-A8A8-D1926F0DEE70`;
    return this.http
      .get<any>(URL, { headers })
      .pipe(map((hotelOptions: any) => {
        return hotelOptions
      }),
        catchError(
          this.handleError
        )
      );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`handleBookingService.handleError ${errMsg}`);
    return throwError(error);
  }

  selectParking(event: MatSelectChange) {
    this.selectedParking = event?.value;

    if (this.selectedParking?.subscriptionParking == true) {
      const endDate = new Date(this.selectedParking?.subscriptionParkingEndDate);
      if (this.showSimpleBooking) {
        this.bookingForm.patchValue({
          simpleArrivalDate: endDate,
          simpleArrivalTime: moment(endDate).format('HH:mm')
        });
      }
    }

    this.additionalServices = this.selectedParking?.additionalServices ?? [];

    if (this.additionalServices && this.additionalServices.length > 0) {
      this.additionalServices.forEach(function (element: any, index: any) {
        if (typeof element.name === 'string') {
          element.name = JSON.parse(element.name);
        }
        if (typeof element.description === 'string') {
          element.description = JSON.parse(element.description);
        }
      });
    }
    this.updateContinueBookingWithPriceState();
  }

  handleAdditionalServicesChange(services: any[]) {
    if (services && services.length > 0) {
      const keySubmissionService = this.additionalServices.find(service =>
        service.name?.en?.toLowerCase() == ('submission of key') ||
        service.name?.sv?.toLowerCase() == ('inlämning av nyckel')
      );

      if (keySubmissionService && !services.find(s => s.id === keySubmissionService.id)) {
        const updatedServices = [...services, keySubmissionService];
        this.bookingForm.get('additionalServices')?.setValue(updatedServices, { emitEvent: false });
      }
    }
  }

  getAvailableParkingsForOrganization(periodFrom: string, periodTo: string, discountCode: string) {
    this.isLoadingParkings = true;
    let orgId = this.organization?.organizationId;

    this.cartService
      .getAvailableParkings(orgId, periodFrom, periodTo, discountCode)
      .pipe(
        timeout(30000),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            console.error('API call timed out after 30 seconds');
            this.isLoadingParkings = false;
            this.bookingForm.get('parking')?.setErrors({ timeout: true });
            return of(null);
          }
          return throwError(() => error);
        })
      )
      .subscribe(parkings => {
        this.isLoadingParkings = false;
        if (this.organization?.name?.toLocaleLowerCase() == 'tui' || this.organization?.name?.toLocaleLowerCase() == 'nazar') {
          this.parkings = parkings?.parkings.filter((parking: any) => {
            return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
          })
        } else if (this.organization?.name?.toLocaleLowerCase() == 'ving') {
          const vingParking = parkings?.parkings.filter((parking: any) => {
            return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
          })
          this.selectedParking.availableParkingSpots = vingParking && vingParking[0] && vingParking[0]?.availableParkingSpots;
          return;
        }
        else {
          this.parkings = parkings?.parkings?.reverse();
        }

        if (this.bookingForm.get('subscription')?.value) {
          this.parkings = parkings?.parkings?.filter((parking: any) => parking.subscriptionParking == true);
        } else {
          this.parkings = parkings?.parkings?.filter((parking: any) => parking.subscriptionParking == false);
        }

        const defaultParkingExists = this.parkings.filter((parking: any) => {
          return (parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26' || parking.id == 'c797769e-66bf-4283-96c5-b16f00e5e126');
        })

        if (defaultParkingExists.length > 0) {
          this.bookingForm.controls['parking'].setValue(defaultParkingExists[0]);
          this.selectParking({ value: defaultParkingExists[0] } as MatSelectChange);
        }

        if (discountCode != 'NONE') {
          this.isDiscountCodeWrong = !this.parkings.some((parking: any) => parking.discountCheckAmount > 0 || parking.discountCheckPercent > 0);
        }

        if (this.tentantConfigSortingParking[this.organization?.name?.toLowerCase()]) {
          this.parkings = this.tentantConfigSortingParking[this.organization?.name?.toLowerCase()](this.parkings);
        }

        // Auto-select default parking for flygets organizations
        if (this.organization?.name?.toLowerCase() === 'flygets.se' || this.organization?.name?.toLowerCase() === 'nazar' || this.organization?.name?.toLowerCase() === 'tui' || this.organization?.name?.toLowerCase() === 'ving') {
          const defaultParkingExists = this.parkings.filter((parking: any) => {
            return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
          });

          if (defaultParkingExists.length > 0) {
            this.bookingForm.controls['parking'].setValue(defaultParkingExists[0]);
            this.selectParking({ value: defaultParkingExists[0] } as MatSelectChange);
          }
        }
      });
  }

  checkBaggage(e: MatCheckboxChange) {
    this.bookingForm.controls['onlyHandBaggage'].setValue(e.checked);
  }

  checkOverrideParking(e: MatCheckboxChange) {
    this.bookingForm.controls['overrideParking'].setValue(e.checked);
    if (this.bookingForm.controls['overrideParking'].value) {
      this.hasAvailableParking = true;
    }
  }

  isBookingFormValid(): boolean {
    const form = this.bookingForm;
    if (!form) return false;

    // 1. Organization
    const org = this.organization || form.get('organization')?.value;
    if (!org) return false;

    // 2. Customer Info (firstname, lastname, email, persons, carid)
    const firstname = form.get('firstname')?.value?.toString()?.trim();
    const lastname = form.get('lastname')?.value?.toString()?.trim();
    const email = form.get('email')?.value?.toString()?.trim();
    const persons = form.get('persons')?.value;
    const isCarIdValid = form.get('carid')?.valid ?? false;

    if (!firstname || !lastname || !email || !persons || !isCarIdValid) {
      return false;
    }

    const orgName = (this.organization?.name || form.get('organization')?.value?.name)?.toLowerCase();

    // 3. Package or Parking selection
    if (orgName === 'ving') {
      if (!form.get('travelAgency')?.value) return false;
    } else {
      if (!this.selectedParking || !form.get('parking')?.value) return false;
    }

    // 4. Departure & Arrival Details
    if (this.showSimpleBooking) {
      const isSub = !!form.get('subscription')?.value;
      const depDate = form.get('simpleDepartureDate')?.value;
      const depTime = form.get('simpleDepartureTime')?.value;
      if (!depDate || !depTime) return false;

      if (!isSub) {
        const arrDate = form.get('simpleArrivalDate')?.value;
        const arrTime = form.get('simpleArrivalTime')?.value;
        if (!arrDate || !arrTime) return false;
      }
    } else {
      const departureType = form.get('departureType')?.value;
      const arrivalType = form.get('arrivalType')?.value;
      const isSub = !!form.get('subscription')?.value;

      // Departure check
      if (departureType === 'flight') {
        const depDate = form.get('flightDepartureDate')?.value;
        const depNum = form.get('flightDepartureNumber')?.value;
        if (!depDate || !depNum) return false;
      } else if (departureType === 'hotel') {
        const depHotelDate = form.get('hotelDepartureDate')?.value;
        const depHotelTime = form.get('hotelDepartureTime')?.value;
        if (!depHotelDate || !depHotelTime) return false;
      } else {
        return false;
      }

      // Arrival check (if not subscription)
      if (!isSub) {
        if (arrivalType === 'flight') {
          const arrDate = form.get('flightArrivalDate')?.value;
          const arrNum = form.get('flightArrivalId')?.value || form.get('flightArrivalNumber')?.value;
          if (!arrDate || !arrNum) return false;
        } else if (arrivalType === 'hotel') {
          const arrHotelDate = form.get('hotelArrivalDate')?.value;
          const arrHotelTime = form.get('hotelArrivalTime')?.value;
          if (!arrHotelDate || !arrHotelTime) return false;
        } else {
          return false;
        }
      }
    }

    return true;
  }

  get calculatedPrice(): number {
    const orgName = (this.organization?.name || this.bookingForm?.get('organization')?.value?.name)?.toLowerCase();

    if (orgName === 'ving') {
      const selectedBundle = this.productOption?.find(b => b.value === this.bookingForm?.get('travelAgency')?.value);
      return selectedBundle ? selectedBundle.price : 0;
    }

    const parkingPrice = Number(this.selectedParking?.totalPrice ?? this.selectedParking?.price ?? 0);

    if (orgName === 'flygets.se') {
      const selectedServices = this.bookingForm?.get('additionalServices')?.value || [];
      const servicesPrice = selectedServices.reduce((sum: number, service: any) => {
        return sum + Number(service?.totalPrice ?? service?.price ?? 0);
      }, 0);
      return parkingPrice + servicesPrice;
    }

    return parkingPrice;
  }

  checkContinueBookingWithPrice(e: MatCheckboxChange) {
    this.bookingForm.controls['continueBookingWithPrice'].setValue(e.checked);
    if (e.checked) {
      const currentVal = this.bookingForm.controls['customPrice'].value;
      if (currentVal === null || currentVal === undefined || currentVal === '') {
        this.bookingForm.controls['customPrice'].setValue(this.calculatedPrice);
      }
    }
  }

  updateContinueBookingWithPriceState() {
    const control = this.bookingForm?.get('continueBookingWithPrice');
    if (!control) return;

    if (this.isBookingFormValid()) {
      if (control.disabled) {
        control.enable({ emitEvent: false });
      }
    } else {
      if (control.value) {
        control.setValue(false, { emitEvent: false });
        this.bookingForm.get('customPrice')?.setValue(null, { emitEvent: false });
      }
      if (control.enabled) {
        control.disable({ emitEvent: false });
      }
    }
  }

  resetForm() {
    this.isResetting = true;
    this.bookingForm.reset({
      carid: 'XXX123',
      departureType: 'flight',
      arrivalType: 'flight',
      parking: null,
    });
    this.bookingForm.controls['flightArrivalId'].reset('');
    this.bookingForm.controls['flightArrivalNumber'].reset('');
    this.bookingForm.controls['parking'].reset('');
    this.bookingForm.controls['parking'].setErrors(null);
    // Clear component state variables
    this.selectedParking = null;
    this.selectedFlight = null;
    this.selectedDeparture = null;
    this.selectedArrival = null;
    this.organization = null;
    this.parkings = [];
    this.additionalServices = [];
    this.hotelOptions = [];
    this.departureFlights = [];
    this.arrivalFlights = [];
    this.showSimpleBooking = false;
    this.hasAvailableParking = true;
    this.departureTerminal = null;
    this.arrivalTerminal = null;
    this.parkings = [];
    this.isResetting = false;
    this.updateContinueBookingWithPriceState();
    window.scroll(0, 0);
  }

  getFlightsByDate(date: any, type: string) {
    const pickedDate = date.value.format('YYYY-MM-DD');
    if (type === 'departure') {
      this.minArrivalDate = pickedDate;
      this.isLoadingDeparture = true;
      this.bookingForm.controls['flightDepartureNumber'].reset('');
      this.shuttleBussService
        .getFlights(pickedDate, type)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          flightInfo => {
            this.departureFlights = flightInfo
              .filter(
                flight =>
                  flight.departureTime.scheduled > moment().format()
              )
              .sort((a, b) =>
                a.departureTime.scheduled < b.departureTime.scheduled ? -1 : 1
              );
            this.isLoadingDeparture = false;
            this.filteredOptionsFlightsDepartures = this.bookingForm.controls[
              'flightDepartureNumber'
            ].valueChanges.pipe(
              startWith(''),
              map(value => this._filterAutocompleteDepartures(value))
            );
          },
          error => {
            this.isLoadingDeparture = false;
            console.error(error);
            this.snackbar.openSnackBar(
              `Det gick inte att hämta flightnummer, vänligen försök igen - (${error.statusText})`,
              ''
            );
          }
        );
    }
    if (type === 'arrival') {
      this.isLoadingArrival = true;
      this.bookingForm.controls['flightArrivalId'].reset('');
      this.bookingForm.controls['flightArrivalNumber'].reset('');
      this.shuttleBussService
        .getFlights(pickedDate, type)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          flightInfo => {
            this.arrivalFlights = flightInfo
              .filter(
                flight =>
                  flight.arrivalTime.scheduled > moment().format()
              )
              .sort((a, b) => (a.arrivalTime.scheduled < b.arrivalTime.scheduled ? -1 : 1));
            this.isLoadingArrival = false;
            this.filteredOptionsFlightsArrivals = this.bookingForm.controls[
              'flightArrivalNumber'
            ].valueChanges.pipe(
              startWith(''),
              map(value => this._filterAutocompleteArrivals(value))
            );
          },
          error => {
            this.isLoadingArrival = false;
            console.error(error);
            this.snackbar.openSnackBar(
              `Det gick inte att hämta flightnummer, vänligen försök igen - (${error.statusText})`,
              ''
            );
          }
        );
    }
  }

  openBottomSheet() {
    let baggageVar = 1;
    if (this.bookingForm.controls['onlyHandBaggage'].value === true) {
      baggageVar = 0;
    }
    const isContinueBookingWithPrice = this.bookingForm.controls['continueBookingWithPrice']?.value ?? false;
    const customPriceInput = this.bookingForm.controls['customPrice']?.value;
    const resolvedPrice = isContinueBookingWithPrice
      ? (customPriceInput !== null && customPriceInput !== undefined && customPriceInput !== '' ? Number(customPriceInput) : this.calculatedPrice)
      : this.calculatedPrice;

    const customerData: any = {
      order: {
        organizationId: this.organization?.organizationId,
        bundleCode: this.selectedParking?.bundleCode,
        productCode: (this.bookingForm.get('organization')?.value?.name?.toLowerCase() === 'ving') ? null : this.selectedParking?.productCode,
        comment: this.bookingForm.controls['comment'].value ?? ""
      },
      customer: {
        firstname: this.bookingForm.controls['firstname'].value,
        lastname: this.bookingForm.controls['lastname'].value,
        email: this.bookingForm.controls['email'].value ?? "",
        cellular: this.bookingForm.controls['cellular'].value ?? ""
      },
      parking: {
        parkingId: this.selectedParking?.id,
        productCode: this.selectedParking?.productCode,
        carId: this.bookingForm.controls['carid'].value,
        parkingFrom: this.getParkingDateTime('departure'),
        parkingTo: this.showSimpleBooking
          ? moment(this.getParkingDateTime('arrival'), 'YYYY-MM-DDTHH:mm:ss').subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss')
          : ((this.bookingForm.controls['arrivalType'].value === 'flight')
            ? moment(this.getParkingDateTime('arrival'), 'YYYY-MM-DDTHH:mm:ss').subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss')
            : moment(this.getParkingDateTime('arrival'), 'YYYY-MM-DDTHH:mm:ss').subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss')),
        comment: this.bookingForm.controls['comment'].value ?? "",
        extendPeriod: 0,
        passengers: this.bookingForm.get('subscription')?.value ? null : this.bookingForm.controls['persons'].value,
        parkingCapacityMultiplier: this.selectedParking?.parkingCapacityMultiplier
      },
      internalBooking: true,
      totalPrice: this.calculatedPrice
    };

    const arrivalHotel = this.bookingForm.controls['arrivalHotel'].value;
    const departureHotel = this.bookingForm.controls['departureHotel'].value;

    let departureTerminal = departureHotel || this.departureTerminal;
    let arrivalTerminal = arrivalHotel || this.arrivalTerminal;

    if ((this.selectedParking?.overbooking == true) && (this.organization?.name?.toLowerCase() == 'flygets.se' || this.organization?.name?.toLowerCase() == 'ving' || this.organization?.name?.toLowerCase() == 'quality hotel arlanda xpo parkering') && this.selectedParking?.availableParkingSpots <= 0) {
      customerData.parking.overbooked = 1;
    }

    if (this.organization?.name?.toLowerCase() === 'flygets.se' || this.organization?.name?.toLowerCase() === 'nazar' || this.organization?.name?.toLowerCase() === 'tui' || this.organization?.name?.toLowerCase() === 'ving') {

      let departureFlightdate: any;
      let arrivalFlightdate: any;
      let hotelShuttleDepartureDate: any;
      let hotelShuttleArrivalDate: any;
      let isArrivalFlightDate: any;

      if (this.bookingForm.controls['departureType'].value === 'flight') {
        departureFlightdate = this.selectedDeparture?.departureTime?.scheduled
          ? new Date(this.selectedDeparture?.departureTime.scheduled).toString().replace(/\s\(.*\)$/, "")
          : undefined;
      } else if (this.bookingForm.controls['departureType'].value === 'hotel') {
        hotelShuttleDepartureDate = this.combineDateTime(this.bookingForm.controls['hotelDepartureDate'].value, this.bookingForm.controls['hotelDepartureTime'].value);
      }

      if (this.bookingForm.controls['arrivalType'].value === 'flight') {
        isArrivalFlightDate = moment(this.selectedArrival.arrivalTime.scheduled).format();
        arrivalFlightdate = this.selectedArrival?.arrivalTime?.scheduled
          ? new Date(this.selectedArrival?.arrivalTime.scheduled).toString().replace(/\s\(.*\)$/, "")
          : undefined;
      } else if (this.bookingForm.controls['arrivalType'].value === 'hotel') {
        hotelShuttleArrivalDate = this.combineDateTime(this.bookingForm.controls['hotelArrivalDate'].value, this.bookingForm.controls['hotelArrivalTime'].value);
      }

      customerData.shuttles = [
        {
          stationcode: 'ARN',
          shuttletypecode: 'flygets-p1-airport-transfer',
          productcode: 'SHUTDEP',
          shuttledate: this.getParkingDateTime('departure'),
          flightnr: this.bookingForm.controls['flightDepartureNumber'].value || null,
          flightdate: departureFlightdate,
          flightdeparturedate: this.selectedDeparture?.flightLegIdentifier?.flightDepartureDateUtc ?? null,
          flightterminal: this.departureTerminal ?? null,
          terminal: departureTerminal,
          passengers: (this.bookingForm.controls['persons'].value)?.toString(),
          childseats: 0,
          baggage: baggageVar,
          comment: this.bookingForm.controls['comment'].value ?? ""
        },
        {
          stationcode: 'ARN',
          shuttletypecode: 'flygets-p1-parking-transfer',
          productcode: 'SHUTARR',
          shuttledate: (isArrivalFlightDate ? (
            this.bookingForm.controls['arrivalType'].value === 'flight' ? this.getShuttleDate(moment(this.getParkingDateTime('arrival')).subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss'), baggageVar) : this.getShuttleDate(moment(this.getParkingDateTime('arrival')).format('YYYY-MM-DDTHH:mm:ss'), baggageVar)) : (this.bookingForm.controls['arrivalType'].value === 'flight' ? (moment(this.getParkingDateTime('arrival')).subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss')) : (moment(this.getParkingDateTime('arrival')).format('YYYY-MM-DDTHH:mm:ss')))),
          flightdate: arrivalFlightdate,
          flightdeparturedate: this.selectedArrival?.flightLegIdentifier?.flightDepartureDateUtc ?? null,
          flightnr: this.bookingForm.controls['flightArrivalId'].value || null,
          flightterminal: this.arrivalTerminal ?? null,
          terminal: arrivalTerminal,
          passengers: (this.bookingForm.controls['persons'].value)?.toString(),
          childseats: 0,
          baggage: baggageVar,
          comment: this.bookingForm.controls['comment'].value ?? ""
        }
      ]
    }

    if (this.additionalServices) {
      customerData.additionalServices = this.bookingForm.controls['additionalServices'].value ?? [];
    }

    if (this.organization?.name?.toLowerCase() == 'quality hotel arlanda xpo parkering' && this.bookingForm.controls['bookingNumber']?.value) {
      customerData.order.externalBookingReference = this.bookingForm.controls['bookingNumber']?.value
    }

    this.isLoading = true;
    this.shuttleBussService
      .addOrderBundle(customerData)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(cart => {
        if (cart) {
          this.isLoading = false;
          const sheetRef = this.bottomSheet.open(InternalBookingSummaryComponent, {
            data: {
              cart,
              customer: customerData,
              customPrice: isContinueBookingWithPrice ? resolvedPrice : 0
            },
            panelClass: 'bottom-sheet-container'
          });
          sheetRef
            .afterDismissed()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(data => {
            });
        }
      },
        (error: any) => {
          console.error(error);
          this.snackbar.openSnackBar(`Något gick fel... (${error.status})`, error.message);
          this.isLoading = false;
        });
  }

  getShuttleDate(date: string, hasBaggage: any) {
    if (!date) return '';
    const flightDate = new Date(date);
    const minutesToAdd = hasBaggage ? 45 : 25;
    flightDate.setMinutes(flightDate.getMinutes() + minutesToAdd);
    return this.formatDate(flightDate);
  };

  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  combineDateTime(date: any, time: any): Date {
    if (!time) {
      return new Date(date);
    }
    time = time.split(":")
    const combinedDate = new Date(date);
    combinedDate.setHours(parseInt(time[0]));
    combinedDate.setMinutes(parseInt(time[1]));
    combinedDate.setSeconds(0);
    combinedDate.setMilliseconds(0);
    return combinedDate;
  }

  getParkingDateTime(type: 'departure' | 'arrival'): string {
    if (this.showSimpleBooking) {
      if (type === 'departure') {
        const date = this.bookingForm.get('simpleDepartureDate')?.value;
        const time = this.bookingForm.get('simpleDepartureTime')?.value;
        return moment(this.combineDateTime(date, time)).format('YYYY-MM-DDTHH:mm:ss');
      } else {
        const date = this.bookingForm.get('simpleArrivalDate')?.value;
        const time = this.bookingForm.get('simpleArrivalTime')?.value;
        return moment(this.combineDateTime(date, time)).format('YYYY-MM-DDTHH:mm:ss');
      }
    } else {
      if (type === 'departure') {
        const departureType = this.bookingForm.get('departureType')?.value;
        if (departureType === 'hotel') {
          const date = this.bookingForm.get('hotelDepartureDate')?.value;
          const time = this.bookingForm.get('hotelDepartureTime')?.value;
          return moment(this.combineDateTime(date, time)).format('YYYY-MM-DDTHH:mm:ss');
        } else {
          // Use the actual parking time from the selected option, not the flight departure date
          return moment(this.bookingForm.controls['parkingfrom'].value).format('YYYY-MM-DDTHH:mm:ss');
        }
      } else {
        const arrivalType = this.bookingForm.get('arrivalType')?.value;
        if (arrivalType === 'hotel') {
          const date = this.bookingForm.get('hotelArrivalDate')?.value;
          const time = this.bookingForm.get('hotelArrivalTime')?.value;
          return moment(this.combineDateTime(date, time)).format('YYYY-MM-DDTHH:mm:ss');
        } else {
          return moment(this.bookingForm.controls['flightArrivalDate'].value).set({ h: this.arriveHour, m: this.arriveMinute, s: this.arriveSecond }).add(1, 'hour').format('YYYY-MM-DDTHH:mm:ss');
        }
      }
    }
  }

  onHotelDepartureDateChange(event: any) {
    this.minHotelArrivalDate = event.value;
    this.minArrivalDate = event.value;
    this.showParkingOptions();
  }

  onSimpleDepartureDateChange(event: any) {
    this.minSimpleArrivalDate = event.value;
  }

  onFlightDepartureDateChange(event: any) {
    this.minArrivalDate = event.value;
    this.minHotelArrivalDate = event.value;
  }

  onFlightArrivalDateChange(event: any) {
    // No specific action needed for arrival date change
  }

  onDepartureTypeChange(value: string) {
    if (value === 'flight') {
      // Clear hotel fields
      this.bookingForm.patchValue({
        hotelDepartureDate: '',
        hotelDepartureTime: '',
        departureHotel: ''
      });
    } else {
      // Clear flight fields
      this.bookingForm.patchValue({
        flightDepartureDate: '',
        flightDepartureNumber: '',
        parkingfrom: ''
      });
      this.selectedFlight = null;
      this.selectedDeparture = null;
    }
  }

  onArrivalTypeChange(value: string) {
    if (value === 'flight') {
      // Clear hotel fields
      this.bookingForm.patchValue({
        hotelArrivalDate: '',
        hotelArrivalTime: '',
        arrivalHotel: ''
      });
    } else {
      // Clear flight fields
      this.bookingForm.patchValue({
        flightArrivalDate: '',
        flightArrivalNumber: '',
        flightArrivalId: ''
      });
      this.selectedArrival = null;
    }
  }

  generateTimeOptions() {
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of [0, 15, 30, 45]) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.timeOptions.push(timeString);
      }
    }

    // Generate hotel arrival time options with 10, 30, 50 minutes
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of [10, 30, 50]) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.hotelArrivalTimeOptions.push(timeString);
      }
    }
  }

  filterTimeOptions(value: string): string[] {
    if (!value) return this.timeOptions;
    const filterValue = value.toLowerCase();
    return this.timeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  filterHotelArrivalTimeOptions(value: string): string[] {
    if (!value) return this.hotelArrivalTimeOptions;
    const filterValue = value.toLowerCase();
    return this.hotelArrivalTimeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
    this.orgSubscription.unsubscribe();
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
